<template>
  <v-row>
    <v-col cols="12">
      <gg-card>
        <gg-card-header>Create New Database</gg-card-header>
        <gg-card-text>
          <create-database-form
            :loading="!restrictionsLoaded"
            @database-created="reloadDatabases"
          />
        </gg-card-text>
      </gg-card>
    </v-col>
<!--    <v-col cols="12">-->
<!--      <gg-card>-->
<!--        <gg-card-header>Manage Databases</gg-card-title>-->
<!--        &lt;!&ndash; Check Database &ndash;&gt;-->
<!--        <action-database :label-text="'Check Database'"-->
<!--                         :modal-action-text="'checked'"-->
<!--                         :modal-title="'Checking Database'"-->
<!--                         :button-text="'Check Database'"-->
<!--                         :uapi-function="'check_database'" />-->
<!--        &lt;!&ndash; Repair Database &ndash;&gt;-->
<!--        <action-database :label-text="'Repair Database'"-->
<!--                         :modal-action-text="'repaired'"-->
<!--                         :modal-title="'Repairing Database'"-->
<!--                         :button-text="'Repair Database'"-->
<!--                         :uapi-function="'repair_database'" />-->
<!--      </gg-card>-->
<!--    </v-col>-->
    <v-col cols="12">
      <gg-card heading="Current Databases">
        <gg-card-header>
          <v-row>
            <v-col cols="12" md="6" class="pt-md-3">
              Manage Databases
            </v-col>
            <v-col cols="12" md="6" class="font-weight-regular">
              <gg-text-field
                v-model="searchDb"
                append-icon="mdi-magnify"
                hide-details
                placeholder="Search"
              />
            </v-col>
          </v-row>
        </gg-card-header>
        <gg-card-text>
          <databases-table
            :search="searchDb"
            :loading="!databasesLoaded && !restrictionsLoaded"
            @table-action-completed="reloadDatabases"
          />
        </gg-card-text>
      </gg-card>
    </v-col>
    <!-- Create new user -->
<!--    <v-col cols="12">-->
<!--      <gg-card heading="Add New User">-->
<!--        <create-user-form></create-user-form>-->
<!--      </gg-card>-->
<!--    </v-col>-->
    <!-- Add user to database -->
<!--    <v-col cols="12">-->
<!--      <gg-card heading="Add User to Database">-->
<!--        <add-user-to-database @action-completed="reloadDatabases"></add-user-to-database>-->
<!--      </gg-card>-->
<!--    </v-col>-->
    <!-- List users -->
<!--    <v-col cols="12">-->
<!--      <gg-card heading="Current Users">-->
<!--        <users-table-->
<!--          :loading="!usersLoaded"-->
<!--          @table-action-completed="reloadUsers"-->
<!--        />-->
<!--      </gg-card>-->
<!--    </v-col>-->
  </v-row>
</template>

<script>
import { mapActions } from 'vuex'
import CreateDatabaseForm from '@/components/Services/Hosting/Shared/Mysql/Databases/CreateDatabaseForm'
// import ActionDatabase from '@/components/Services/Hosting/Shared/Mysql/Databases/ActionDatabase'
import DatabasesTable from '@/components/Services/Hosting/Shared/Mysql/Databases/DatabasesTable'
// import AddUserToDatabase from '@/components/Services/Hosting/Shared/Mysql/Users/AddUserToDatabase'
// import CreateUserForm from '@/components/Services/Hosting/Shared/Mysql/Users/CreateUserForm'
// import UsersTable from '@/components/Services/Hosting/Shared/Mysql/Users/UsersTable'

export default {
  name: 'MySqlView',
  components: {
    CreateDatabaseForm,
    // ActionDatabase,
    DatabasesTable,
    // AddUserToDatabase,
    // CreateUserForm,
    // UsersTable,
  },
  data () {
    return {
      restrictionsLoaded: false,
      databasesLoaded: false,
      selectedDB: '',
      usersLoaded: false,
      searchDb: ''
    }
  },
  methods: {
    ...mapActions({
      getMysqlRestrictions: 'mysql/getMysqlRestrictions',
      getMysqlDatabases: 'mysql/getMysqlDatabases',
      getMysqlUsers: 'mysql/getMysqlUsers',
      reportError: 'reportError',
    }),
    async reloadDatabases () {
      this.databasesLoaded = false
      try {
        await this.getMysqlDatabases(this.$route.query.user)
      } catch (e) {
        this.reportError(e)
      }
      this.databasesLoaded = true
    },
    async reloadUsers () {
      this.usersLoaded = false
      try {
        await this.getMysqlUsers()
      } catch (e) {
        this.reportError(e)
      }
      this.usersLoaded = true
    }
  },
  async created () {
    try {
      await this.getMysqlRestrictions(this.$route.query.user)
    } catch (e) {
      this.reportError(e)
    }
    this.restrictionsLoaded = true
    this.reloadDatabases()
    // this.reloadUsers()
  },
}
</script>
